// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

export const featureIcons = new Map();
featureIcons.set('3rd row seats', '3rd-row-seats');
featureIcons.set('3e rangée', '3rd-row-seats');
featureIcons.set('abs brakes', 'specs-abs');
featureIcons.set('système de freinage antiblocage', 'specs-abs');
featureIcons.set('adaptive suspension', 'suspension');
featureIcons.set('alloy wheels', 'specs-wheel');
featureIcons.set('roues en alliage', 'specs-wheel');
featureIcons.set(
	'auto dimming rear view mirror',
	'auto-dimming-rear-view-mirror'
);
featureIcons.set(
	'rétroviseur à atténuation automatique',
	'auto-dimming-rear-view-mirror'
);
featureIcons.set('auto high-beam headlights', 'headlight');
featureIcons.set('auto tilt-away steering wheel', 'steeringwheel');
featureIcons.set('auto-dimming door mirrors', 'dimming-door-mirrors');
featureIcons.set('auto-leveling suspension', 'suspension');
featureIcons.set(
	'automatic temperature control',
	'automatic-temperature-control'
);
featureIcons.set('climatisation automatique', 'automatic-temperature-control');
featureIcons.set('blind spot sensor', 'blind-spot-sensor');
featureIcons.set('capteur d&apos;angle mort', 'blind-spot-sensor');
featureIcons.set('cd player', 'cd-player');
featureIcons.set('ceramic disc brakes', 'brakes');
featureIcons.set('chrome wheels', 'specs-wheel');
featureIcons.set('roues chromées', 'specs-wheel');
featureIcons.set(
	'distance pacing cruise control',
	'distance-pacing-cruise-control'
);
featureIcons.set(
	'régulateur de vitesse adaptatif',
	'distance-pacing-cruise-control'
);
featureIcons.set('dual rear wheels', 'specs-wheel');
featureIcons.set('roues arrière jumelées', 'specs-wheel');
featureIcons.set('electronic stability', 'traction-control');
featureIcons.set('contrôle électronique de la stabilité', 'traction-control');
featureIcons.set('emergency communication system', 'alert');
featureIcons.set('système de communication d&apos;urgence', 'alert');
featureIcons.set('entertainment system', 'entertainment-system');
featureIcons.set('système de divertissement', 'entertainment-system');
featureIcons.set('exterior parking camera front', 'backup-camera');
featureIcons.set('exterior parking camera left', 'backup-camera');
featureIcons.set('exterior parking camera rear', 'backup-camera');
featureIcons.set('exterior parking camera right', 'backup-camera');
featureIcons.set('front dual zone a/c', 'air-conditioning');
featureIcons.set(
	'climatisation à deux zones à l&apos;avant',
	'air-conditioning'
);
featureIcons.set('climatisation à l&apos;arrière', 'air-conditioning');
featureIcons.set('fully automatic headlights', 'headlight');
featureIcons.set('lave-phares', 'headlight');
featureIcons.set('phares entièrement automatiques', 'headlight');
featureIcons.set('headlight cleaning', 'headlight');
featureIcons.set('headphones', 'headphones');
featureIcons.set('heads up display', 'heads-up-display');
featureIcons.set('heated door mirrors', 'heated-door-mirrors');
featureIcons.set('heated front seats', 'heated-seats');
featureIcons.set('heated rear seats', 'heated-seats');
featureIcons.set('heated rear seats', 'heated-seats');
featureIcons.set('sièges avant chauffants', 'heated-seats');
featureIcons.set('heated steering wheel', 'heated-steering-wheel');
featureIcons.set('high intensity discharge headlights', 'headlight');
featureIcons.set('phares à décharge à haute intensité', 'headlight');
featureIcons.set('internet access capable', 'internet');
featureIcons.set('lane departure', 'lane-departure');
featureIcons.set('sortie de voie', 'lane-departure');
featureIcons.set('leather upholstery', 'leather-upholstery');
featureIcons.set('garniture des sièges en cuir', 'leather-upholstery');
featureIcons.set('low tire pressure warning', 'low-tire-pressure-warning');
featureIcons.set(
	'témoin du système indicateur de pression des pneus',
	'low-tire-pressure-warning'
);
featureIcons.set('massaging driver lumbar support', 'massaging-seat');
featureIcons.set('memory seat', 'interiorcolor');
featureIcons.set('navigation service', 'navigation-system');
featureIcons.set('navigation system', 'navigation-system');
featureIcons.set('système de navigation', 'navigation-system');
featureIcons.set('night vision lights', 'night-vision');
featureIcons.set('vision nocturne', 'night-vision');
featureIcons.set('parking sensors', 'parking-sensors');
featureIcons.set('sonar de stationnement', 'parking-sensors');
featureIcons.set('perimeter/approach lights', 'perimeter-lights');
featureIcons.set('power 2nd row moonroof', 'power-moonroof');
featureIcons.set('power 3rd row moonroof', 'power-moonroof');
featureIcons.set('power convertible roof', 'bodystyle-convertible');
featureIcons.set('power driver seat', 'interiorcolor');
featureIcons.set('siège conducteur à réglage électrique', 'interiorcolor');
featureIcons.set('power moonroof', 'power-moonroof');
featureIcons.set('toit ouvrant à commande électrique', 'power-moonroof');
featureIcons.set('power passenger seat', 'interiorcolor');
featureIcons.set('siège arrière rabattable divisé', 'interiorcolor');
featureIcons.set('premium audio system', 'premium-audio-system');
featureIcons.set('chaîne audio de qualité supérieure', 'premium-audio-system');
featureIcons.set('rain sensing wipers', 'rain-sensing-wipers');
featureIcons.set('essuie-glaces à capteur de pluie', 'rain-sensing-wipers');
featureIcons.set('rear audio controls', 'premium-audio-system');
featureIcons.set('remote keyless entry', 'remote-keyless-entry');
featureIcons.set('télédéverrouillage', 'remote-keyless-entry');
featureIcons.set('reverse sensing system', 'backup-camera');
featureIcons.set('speakers', 'speaker');
featureIcons.set('speed limit sign recognition', 'speed-limit');
featureIcons.set('speed sensitive wipers', 'speed-sensitive-wipers');
featureIcons.set(
	'essuie-glaces sensibles à la vitesse',
	'speed-sensitive-wipers'
);
featureIcons.set('essuie-glace de lunette', 'speed-sensitive-wipers');
featureIcons.set('steering wheel memory', 'steeringwheel');
featureIcons.set('steering wheel mounted audio controls', 'steeringwheel');
featureIcons.set('sun blinds', 'power-moonroof');
featureIcons.set('tonneau cover', 'tonneau-cover');
featureIcons.set('traction control', 'traction-control');
featureIcons.set('antipatinage', 'traction-control');
featureIcons.set('traffic sign recognition', 'traffic-sign');
featureIcons.set('trip computer', 'trip-computer');
featureIcons.set('ordinateur de voyage', 'trip-computer');
featureIcons.set('turn-by-turn navigation service', 'navigation-system');
featureIcons.set('service d&apos;orientation pas à pas', 'navigation-system');
featureIcons.set('ventilated front seats', 'seats-cooled');
featureIcons.set('ventilated rear seats', 'seats-cooled');
featureIcons.set('wireless connectivity', 'specs-bluetooth');
featureIcons.set('wireless phone connectivity', 'specs-bluetooth');
featureIcons.set('connectivité sans fil pour téléphone', 'specs-bluetooth');
featureIcons.set('wireless phone charging', 'wireless-charging');
featureIcons.set('hands free liftgate', 'handsfree-liftgate');
featureIcons.set('wifi hot spot', 'wifi');
featureIcons.set('power liftgate', 'power-liftgate');
featureIcons.set(
	'auto-dimming rearview mirror',
	'auto-dimming-rear-view-mirror'
);
featureIcons.set('illuminated running boards', 'perimeter-lights');
